import { render, staticRenderFns } from "./Abgeschlossen.vue?vue&type=template&id=3af3fdbb&"
import script from "./Abgeschlossen.vue?vue&type=script&lang=js&"
export * from "./Abgeschlossen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports